(function () {
  'use strict';
  const META = '_clairatier_order_display';
  const HANDLE = 'clairabord-eclat-sticker-bebe-a-bord';
  const RAW_FIELDS = ['Personnage', 'Langue', 'Texte haut', 'Texte bas', 'Fondu'];
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  function supported(config) {
    return config && ['fr', 'en', 'it', 'nl', 'pt-PT', 'de', 'es'].includes(config.locale) && config.productHandle === HANDLE &&
      Array.isArray(config.fields) && config.fields.length === 5 &&
      config.fields.every(f => f.raw && f.label && !f.label.includes('translation missing'));
  }
  function localizeProperties(properties, config) {
    if (!supported(config)) return restoreProperties(properties);
    if (config.fields.some(f => own(properties, f.raw) && own(properties, '_' + f.raw) &&
      String(properties[f.raw]) !== String(properties['_' + f.raw]))) return { ...properties };
    const result = { ...properties };
    let previous;
    try { previous = JSON.parse(properties[META] || 'null'); } catch (_) { previous = null; }
    // Only remove presentation keys that match our versioned raw-value record.
    if (previous && previous.version === 1 && Array.isArray(previous.fields)) {
      for (const field of previous.fields) {
        if (config.fields.some(f => f.raw === field.raw) && typeof field.label === 'string' &&
          typeof field.value === 'string' && result[field.label] === field.value) delete result[field.label];
      }
    }
    const records = [];
    for (const field of config.fields) {
      const privateKey = '_' + field.raw;
      const raw = own(properties, privateKey) ? properties[privateKey] : properties[field.raw];
      if (raw === undefined || raw === null) continue;
      const value = String(raw);
      delete result[field.raw];
      result[privateKey] = value;
      const display = field.values && own(field.values, value) ? field.values[value] : value;
      result[field.label] = display;
      records.push({ raw: field.raw, label: field.label, value: display });
    }
    if (records.length) result[META] = JSON.stringify({ version: 1, fields: records });
    return result;
  }
  function restoreProperties(properties) {
    const result = { ...properties };
    let previous;
    try { previous = JSON.parse(properties[META] || 'null'); } catch (_) { return result; }
    if (!previous || previous.version !== 1 || !Array.isArray(previous.fields)) return result;
    for (const field of previous.fields) {
      if (!RAW_FIELDS.includes(field.raw) || typeof field.label !== 'string' ||
        typeof field.value !== 'string' || result[field.label] !== field.value ||
        !own(result, '_' + field.raw)) continue;
      delete result[field.label];
      result[field.raw] = result['_' + field.raw];
    }
    delete result[META];
    return result;
  }
  function sameProperties(a, b) {
    const keys = Object.keys(a);
    return keys.length === Object.keys(b).length && keys.every(k => a[k] === b[k]);
  }
  function localizeLine(line, config) {
    if (line.handle !== HANDLE) return null;
    const properties = localizeProperties(line.properties || {}, config);
    return sameProperties(line.properties || {}, properties) ? null :
      { id: line.key, quantity: line.quantity, properties };
  }
  const IMAGE_SOURCE = '_eclat_media_source';
  function imageVariant(line, config) {
    const props = line.properties || {};
    if (line.handle !== HANDLE || props._eclat_version !== 'eclat-baby-sun-v1') return null;
    const language = props._Langue || props.Langue;
    const fade = props._Fondu || props.Fondu;
    const message = config.stickerMessages?.[language];
    if (!message || (props['_Texte haut'] || props['Texte haut']) !== message.top ||
      (props['_Texte bas'] || props['Texte bas']) !== message.bottom) return null;
    const sku = ['eclat', props._eclat_preset, language, fade].join('|');
    const matches = (Array.isArray(config.imageVariants) ? config.imageVariants : []).filter(v => v.sku === sku);
    return matches.length === 1 && Number.isSafeInteger(matches[0].price) && matches[0].price > 0 && matches[0].available && matches[0].image ? matches[0] : null;
  }
  async function migrateImages(cart, config, request, root) {
    let changed = false;
    const readCart = async () => {
      const response = await request(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    };
    const change = async update => {
      const response = await request(root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(update)
      });
      if (!response.ok) throw new Error('Cart image unavailable');
      return response.json();
    };
    for (let attempt = 0; attempt < 100; attempt++) {
      const marked = cart.items.find(line => line.handle === HANDLE && line.properties?.[IMAGE_SOURCE]);
      if (marked) {
        let source;
        try { source = JSON.parse(marked.properties[IMAGE_SOURCE]); } catch (_) { throw new Error('Invalid image migration'); }
        const variant = imageVariant(marked, config);
        if (source.version !== 1 || typeof source.key !== 'string' || !Number.isInteger(source.quantity) || !variant || Number(marked.variant_id) !== Number(variant.id)) throw new Error('Invalid image migration');
        const original = cart.items.find(line => line.key === source.key);
        if (original) {
          if (Number(original.variant_id) !== 53792188465488 || original.quantity !== source.quantity || marked.quantity !== source.quantity ||
            !sameProperties(original.properties || {}, Object.fromEntries(Object.entries(marked.properties).filter(([key]) => key !== IMAGE_SOURCE)))) throw new Error('Cart changed during image migration');
          cart = await change({ id: original.key, quantity: 0 });
          if (cart.items.some(line => line.key === original.key)) throw new Error('Cart image unchanged');
        } else {
          const properties = { ...marked.properties };
          delete properties[IMAGE_SOURCE];
          cart = await change({ id: marked.key, quantity: marked.quantity, properties });
          if (cart.items.some(line => line.key === marked.key && line.properties?.[IMAGE_SOURCE])) throw new Error('Cart image unchanged');
        }
        changed = true;
        continue;
      }
      const original = cart.items.find(line => Number(line.variant_id) === 53792188465488 && imageVariant(line, config));
      if (!original) return changed;
      const variant = imageVariant(original, config);
      const marker = JSON.stringify({ version: 1, key: original.key, quantity: original.quantity });
      const response = await request(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: original.quantity, properties: { ...original.properties, [IMAGE_SOURCE]: marker } }] })
      });
      if (!response.ok) throw new Error('Cart image unavailable');
      cart = await readCart();
      if (!cart.items.some(line => line.properties?.[IMAGE_SOURCE] === marker && Number(line.variant_id) === Number(variant.id))) throw new Error('Cart image unchanged');
      changed = true;
    }
    throw new Error('Cart image migration incomplete');
  }
  function prepareForm(form, config) {
    if (form.dataset.clairatierOrderLocalized) return;
    const outputs = new Map();
    for (const field of config.fields) {
      const input = form.querySelector('[data-eclat-order-' + field.hook + ']');
      if (!input || ![field.raw, '_' + field.raw].some(k => input.name === 'properties[' + k + ']')) return;
    }
    for (const field of config.fields) {
      const input = form.querySelector('[data-eclat-order-' + field.hook + ']');
      input.name = 'properties[_' + field.raw + ']';
      const display = document.createElement('input');
      display.type = 'hidden';
      display.name = 'properties[' + field.label + ']';
      display.dataset.clairatierOrderDisplay = field.raw;
      form.appendChild(display);
      outputs.set(field.raw, display);
    }
    const meta = document.createElement('input');
    meta.type = 'hidden';
    meta.name = 'properties[' + META + ']';
    form.appendChild(meta);
    function sync() {
      const raw = {};
      for (const field of config.fields) raw['_' + field.raw] =
        form.querySelector('[data-eclat-order-' + field.hook + ']').value;
      const localized = localizeProperties(raw, config);
      for (const field of config.fields) outputs.get(field.raw).value = localized[field.label] || '';
      meta.value = localized[META] || '';
    }
    // Existing Éclat listeners fill the raw values first. We append display values afterwards.
    const root = form.closest('[data-clairabord-eclat]');
    root.addEventListener('click', sync);
    root.addEventListener('change', sync);
    form.addEventListener('submit', sync);
    sync();
    form.dataset.clairatierOrderLocalized = 'true';
  }
  async function migrateCart(config, request = fetch) {
    const root = config.root.replace(/\/$/, '') + '/';
    const response = await request(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Cart unavailable');
    let cart = await response.json();
    let changed = false;
    // Every change returns the latest cart. Keys and quantities are never taken from a stale initial list.
    for (let attempt = 0; attempt < 25; attempt++) {
      const update = cart.items.map(line => localizeLine(line, config)).find(Boolean);
      if (!update) break;
      const result = await request(root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(update)
      });
      if (!result.ok) throw new Error('Cart localization unavailable');
      const next = await result.json();
      if (next.items.some(line => line.key === update.id && !sameProperties(line.properties || {}, update.properties)))
        throw new Error('Cart localization unchanged');
      cart = next;
      changed = true;
    }
    return await migrateImages(cart, config, request, root) || changed;
  }
  function boot() {
    const element = document.querySelector('[data-clairatier-order-localization]');
    if (!element || element.dataset.initialized) return;
    let config;
    try { config = JSON.parse(element.textContent); } catch (_) { return; }
    const imageConfig = document.querySelector('[data-eclat-native-order-images]');
    if (imageConfig) {
      try { config.imageVariants = JSON.parse(imageConfig.textContent); } catch (_) { return; }
    }
    if (config.productHandle !== HANDLE || typeof config.root !== 'string') return;
    element.dataset.initialized = 'true';
    const prepareForms = () => {
      if (supported(config)) document.querySelectorAll('[data-eclat-purchase]').forEach(form => prepareForm(form, config));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareForms);
    else prepareForms();
    let ready = false;
    const pending = migrateCart(config).then(changed => {
      ready = !changed;
      if (changed) location.reload();
      return changed;
    }).catch(() => { ready = true; return false; });
    let checkoutAllowed = false;
    let checkoutBusy = false;
    function checkCheckout(control, proceed) {
      if (checkoutBusy) return;
      checkoutBusy = true;
      // A previous checkout or another locale can outlive the initial page migration.
      // Re-read the cart immediately before native checkout, using fresh line keys.
      pending.then(async initialChanged => {
        if (initialChanged || !control.isConnected) return;
        if (await migrateCart(config)) { location.reload(); return; }
        checkoutAllowed = true;
        try { proceed(); } finally { checkoutAllowed = false; }
      }).catch(() => {
        // Do not submit unverified presentation data. A fresh click can retry.
      }).finally(() => { checkoutBusy = false; });
    }
    // Finish the small metadata migration before a customer submits checkout or changes quantities.
    document.addEventListener('click', event => {
      if (!event.target.closest) return;
      const checkout = event.target.closest('[name="checkout"],a[href*="/checkout"]');
      if (checkout && !checkoutAllowed) {
        event.preventDefault();
        event.stopImmediatePropagation();
        checkCheckout(checkout, () => checkout.click());
        return;
      }
      if (ready) return;
      const control = event.target.closest('.cart__qty-control');
      if (!control) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      pending.then(changed => { if (!changed && control.isConnected) control.click(); });
    }, true);
    document.addEventListener('submit', event => {
      if (checkoutAllowed || event.submitter?.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const form = event.target;
      const submitter = event.submitter;
      checkCheckout(submitter, () => { if (form.isConnected) form.requestSubmit(submitter); });
    }, true);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { localizeProperties, localizeLine, sameProperties, migrateCart, imageVariant, migrateImages };
  if (typeof document !== 'undefined') {
    // The bridge is at the end of body: guard checkout immediately, even before deferred scripts finish.
    boot();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', () => {
      const element = document.querySelector('[data-clairatier-order-localization]');
      if (!element) return;
      try {
        const config = JSON.parse(element.textContent);
        if (supported(config)) document.querySelectorAll('[data-eclat-purchase]').forEach(form => prepareForm(form, config));
      } catch (_) { /* Keep the existing purchase form available. */ }
    });
  }
})();
